module.exports = __webpack_public_path__ + "media/images/banner-bg-adfd3eaeea48b853699befd67a48c4e1.jpg";